define([
    'text!index2021-cooperate/component/item-marketing.html',
    'index2021-cooperate/mixin/form'
], function(
    tpl,
    FormMixin
){
    return {
        template: tpl,
        mixins: [FormMixin],
        methods: {
            resetForm: function(){
                this.form = {
                    type: 4,
                    projectName: '',
                    contact: '',
                    tel: '',
                    email: '',
                    attch: '',
                    remark: ''
                };
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-cooperate/component/item-marketing.js
// module id = 237
// module chunks = 0